class ImageConsentController {
    imageConsent: any = {};
    submitted: boolean = false;

    static $inject = ['$scope', '$state', 'ImageConsent', 'applicationObservable', 'dialogs'];
    constructor(private $scope, $state, private ImageConsent, private applicationObservable, private dialogs){
        this.init();
    }

    init(){
        this.applicationObservable?.toPromise().then(x => {
            this.imageConsent.imageConsent = this.resolveImageConsent(x.imageConsent);
        });
    }

    submit(){
        this.submitted = true; 
        this.$scope.$broadcast('submitted', true);

        if(!this.imageConsent.$validation()) return;

        this.ImageConsent.update({
             applicationId: this.applicationObservable.applicationId 
            }, this.imageConsent.imageConsent).$promise.then((result) => {
                const genericSuccessText = "Your public profile consent preference has been updated successfully.";
                const emailNotificationText = "A confirmation email will be sent to your email address.";

                this.dialogs.notify("Public profile consent updated", `${genericSuccessText} ${(result.shouldSendEmail ? emailNotificationText : "")}`);
            }, () => {
                this.dialogs.error('Public profile consent update error', 'Unable to update. Please try again later.');
            });
    }

    private resolveImageConsent(imageConsent: boolean | undefined){
        if(imageConsent === undefined){
            return '';
        }

        return imageConsent ? 1 : 0;
    }
}

angular
    .module('app')
    .controller('ImageConsentController', ImageConsentController);